import {Component} from "react"


class SearchIcon extends Component<any> {
    render() {
        return (
            <div className="search-icon">
                <svg
                    width="15"
                    height="15"
                    fill="none"
                    stroke="grey"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <circle cx="45.8%" cy="45.8%" r="33.3%" />
                    <line x1="68.75%" y1="68.75%" x2="91.6%" y2="91.6%" />
                </svg>
            </div>
        )
    }
}

export default SearchIcon
